/**
 * <ChangeSchool />
 *
 * This is ...
 *
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import MyStoreCheckout from 'template/Modals/MyStoreCheckout';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import locale from './locale';
import CreateSchool from 'template/Modals/CreateSchool';
import StartFreeTrial from 'template/Modals/StartFreeTrial';
import './ChangeSchool.scss';
import { fetchUserByToken } from 'containers/Main/ducks/user';
import { clearSchoolDetail } from 'containers/Main/ducks/school-detail';
import { confirm } from 'util/confirm';
import { alert } from 'util/alert'
import { getSubscription } from 'containers/Main/ducks/subscription';

import confirmTeacher from 'controllers/teacher/confirmTeacher'
import deleteSchool from 'controllers/school/deleteSchool'
import beginTrial from 'controllers/user/startTrial';
import getSubscriptionCtrl from 'controllers/payment/getSubscription'
import { isOnlyTeacher } from 'containers/__R';

import femaleUserLogo from 'data/images/female-user-icon.png';

const mapStateToProps = state => ({
  user: state.user,
  gSubscription: state.gSubscription,
});

const mapDispatchToProps = dispatch => {
  return {
    clearSchoolDetail: () => dispatch(clearSchoolDetail()),
    fetchUserByToken: ()=> dispatch(fetchUserByToken()),
    getSubscription: () => dispatch(getSubscription()),
  };
};

class ChangeSchool extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      manageSchool: false,
    }

    this.selectSchool = this.selectSchool.bind(this);
    this.addSchool = this.addSchool.bind(this);
    this.printSchoolRole = this.printSchoolRole.bind(this);
    this.toggleManageSchool = this.toggleManageSchool.bind(this);
    this.acceptInvitation = this.acceptInvitation.bind(this);
  }

  componentWillMount() {
    localStorage.removeItem('SchoolId')
    localStorage.removeItem('role')
    if(global['--subscription-refresher']){
      clearInterval(global['--subscription-refresher'])
    }
    this.props.clearSchoolDetail();
    this.props.getSubscription();
  }

  componentDidMount(){
    //prevent user from hitting the browser back button
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  selectSchool(school) {
    return (e)=>{
      if (this.state.manageSchool) {
        e.preventDefault();
        return;
      }
      getSubscriptionCtrl(school.school_id)
        .then((res)=>{
          const {is_valid, maximum_amount, saas_version} = res.data;

          if(is_valid && maximum_amount.maximum_school!==0){
            localStorage.setItem('schoolId', school.school_id);
            localStorage.setItem('role', this.printSchoolRole(school));
            window.location.href = '/dashboard';
          }else if(!is_valid && saas_version === 0){
            if(school.role_group[0].name === 'school_owner'){
              alert.warning(__('Your free trial is over, please subscribe to one of the plan for further usage, thank you!', locale))
              .then((res)=>{
                browserHistory.push('/account-settings');
              })
              return;
            }else {
              alert.warning(__("This school's free trial is over, please inform the school owner to subscribe one of the plan for further usage, thank you!", locale));
              return 
            }
          }else{
            if(school.role_group[0].name === 'school_owner'){
              alert.warning(__('Your account is no longer active, please update your payment credit card info for further usage, thank you!', locale))
              .then((res)=>{
                browserHistory.push('/account-settings');
              })
              return;
            }else {
              alert.warning(__("This school's account is no longer active, please contact the school's owner, thank you!", locale));
              return 
            }
          }
        
        })
    }
  }

  toggleManageSchool() {
    const {is_valid, maximum_amount, saas_version} = this.props.gSubscription.result;

    if(is_valid && maximum_amount.maximum_school!==0){
      this.setState({
        manageSchool: this.state.manageSchool !== true,
      });
    }else if(!is_valid && saas_version === 0){
      alert.warning(__('Your free trial is over, please subscribe to one of the plan for further usage, thank you!', locale))
      .then((res)=>{
        browserHistory.push('/account-settings');
      })
    }else{
      alert.warning(__('Your account is no longer active, please update your payment credit card info for further usage, thank you!', locale))
      .then((res)=>{
        browserHistory.push('/account-settings');
      })
    }
  }

  addSchool() {
    const {user, gSubscription} = this.props;
    const {school_owned_amount} = user.result;
    const {is_valid, saas_version, maximum_amount} = gSubscription.result;
    const {maximum_school} = maximum_amount;

    if(!is_valid && !isOnlyTeacher()){
      if(saas_version === 0){
        alert.warning(__('Your free trial is over, please subscribe to one of the plan for further usage, thank you!', locale))
        .then((res)=>{
          browserHistory.push('/account-settings');
        })
      }else {
        alert.warning(__('Your account is no longer active, please update your payment credit card info for further usage, thank you!', locale))
        .then((res)=>{
          browserHistory.push('/account-settings');
        })
      }
    }else if(!is_valid && saas_version === 0 && school_owned_amount === 0 && isOnlyTeacher()){
      StartFreeTrial()
        .then(()=>{
          beginTrial()
            .then((res)=>{
              if(res.result === 'success'){
                this.props.fetchUserByToken();
                this.props.getSubscription();
                this.createSchool();
              }else {
                alert.warning(__('You have used the free trial', locale))
              }
            })
        })
    }else if(saas_version === 1 || school_owned_amount < maximum_school) {
      return this.createSchool();
    }else {
      alert.message(__('You are about go over the school limit, please upgrade to higher subscription plan to add more schools', 'header'), __('Upgrade Subscription Plan', 'header'))
    }
  }

  createSchool() {
    CreateSchool().then((res)=>{
      if (res && res.schoolCreated) {
        this.props.fetchUserByToken();
        this.props.getSubscription()
      }
    }).catch((error)=>{
      console.error(error);
    });
  }


  removeSchool(school) {
    return (e)=>{
      confirm(__('Are you sure you want to delete school? This process cannot be undone.', locale), __('', locale))
      .then(()=>{
        deleteSchool(school.school_id)
        .then((res)=> {
          this.props.fetchUserByToken();
          this.props.getSubscription();
        })
        .catch((err)=>{console.error(err)})
      })
      .catch()
    }
  }

  printSchoolRole(school) {
    const {
      role_group = [],
    } = school;

    if (role_group.length > 0 && role_group[0]) {
      if(role_group[0].name == 'school_owner'){
        return __('Principal', locale);
      } else {
        return __('Teacher', locale);
      }
    }
  }

  acceptInvitation(school) {
    return ()=>{
      this.setState({
        confirming: true,
      })

      confirm(__('Proceed to accept the invitation?', locale), __('Accept', locale))
        .then(()=>{
          confirmTeacher(school.school_teacher_id, {confirm_or_not: 'confirmed'})
            .then((res)=>{
              this.props.fetchUserByToken();
              this.props.getSubscription();
            })
            .catch((err)=>{
              this.setState({
                confirming: true,
              })
            })

        })
        .catch(()=>{this.setState({confirming: false})});
    }
  }

  declineInvitation(school) {
    return ()=>{
      this.setState({
        confirming: true,
      })

      confirm(__('Proceed to decline the invitation?', locale), __('Decline', locale))
        .then(()=>{
          confirmTeacher(school.school_teacher_id, {confirm_or_not: 'declined'})
            .then((res)=>{
              this.props.fetchUserByToken();
              this.props.getSubscription();
            })
            .catch((err)=>{
              this.setState({
                confirming: true,
              })
            })
        })
        .catch(()=>{this.setState({confirming: false})});
    }
  }

  render() {
    const {user, gSubscription} = this.props;
    const {saas_version} = gSubscription.result;

    const {
      school_list = [],
      teacher_to_be_confirmed = [],
      school_owned_amount,
    } = user.result;

    const {
      manageSchool,
      confirming,
    } = this.state;
    return (
      <div className='ChangeSchool'>
        <h1>{__('My Schools', locale)}</h1>
        <section className='ChangeSchool--list'>
          <ul className='SchoolList'>
            {teacher_to_be_confirmed.map((school, key)=>{
              return (
                <li key={key}>
                  <div className='SchoolList--item SchoolList--item__toConfirm'>
                    <img src={school.school_logo_thumbnail_1x || femaleUserLogo} className='SchoolList--item--logo'/>
                    <div className='SchoolList--item--name'>{school.school_name}</div>
                    <div className='SchoolList--item--role'>{__('Teacher', locale)}</div>
                    { confirming !== true &&
                      <div className='SchoolList--item--confirm'>
                        <a className='btn btn-default' onClick={this.declineInvitation(school)}>{__('Decline', locale)}</a>
                        <a className='btn btn-primary btn-success' onClick={this.acceptInvitation(school)}>{__('Accept', locale)}</a>
                      </div>
                    }
                  </div>
                </li>
              );
            })}
            {school_list.map((school, key)=>{
              const userCanDeleteSchool = manageSchool === true && school.role_group && school.role_group[0] && school.role_group[0].name == 'school_owner';

              return (
                <li key={key} onClick={this.selectSchool(school)}>
                  <div className='SchoolList--item'>
                    <img src={school.school_logo || femaleUserLogo} className='SchoolList--item--logo'/>
                    <div className='SchoolList--item--name'>{school.school_name}</div>
                    <div className='SchoolList--item--role'>{this.printSchoolRole(school)}</div>

                    { userCanDeleteSchool &&
                        <a className='SchoolList--item--remove' onClick={this.removeSchool(school)}>
                          <i className='fa icon-trash' /> {__('Delete', locale)}
                        </a>
                    }

                  </div>
                </li>
              );
            })}
            { manageSchool !== true &&
              <li className='SchoolList--create' onClick={this.addSchool}>
                <div className='SchoolList--create--plus'><i className='fa icon-plus'></i></div>
                <span>{__('Create New School', locale)}</span>
                {
                  saas_version===1 && school_owned_amount >= 1 && 
                  <span className='SchoolList--create--price'>{__('$79 USD / month per school', locale)}</span>
                }
              </li>
            }
          </ul>
        </section>
        {
          school_owned_amount>0 && 
          <section className='ChangeSchool--manage'>
            <a className='btn-link' onClick={this.toggleManageSchool}>{ manageSchool !== true && __('Delete School', locale)}{ manageSchool == true && __('Confirm', locale)}</a>
          </section>
        }
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeSchool);



// WEBPACK FOOTER //
// ./src/containers/pages/ChangeSchool/index.js